export class Account {
  public id: number;
  public avatar?: string;
  public email: string;
  public weixinName: string;
  public weixinId: string;
  public weixinNick: string;
  public weixinType: number;
  public verifyTypeInfo: number;
  public qrCode?: string;
  public domain: string;
  public appId: string;
  public status: number;
  public level: string;
  public scaleLevel: string;
  public isVerified: boolean;
  public lastSyncStatus?: any;
  public isFromComp: boolean;
  public isBlocked?: boolean;
  public isCompValid: boolean;
  public trialExpired: boolean;
  public trialExpiredAt: Date;
  public copyright?: string;
  public version: number;
  public agreeBroadcast: boolean;
  public funcInfo?: string;
  public isPayOpen: boolean;
  public crmCreate?: Date;
  public gmtCreate: Date;
  public gmtModified: Date;

  constructor(a: Account) {
    this.id = a.id;
    this.avatar = a.avatar;
    this.email = a.email;
    this.weixinName = a.weixinName;
    this.weixinId = a.weixinId;
    this.weixinType = a.weixinType;
    this.weixinNick = a.weixinNick;
    this.verifyTypeInfo = a.verifyTypeInfo;
    this.qrCode = a.qrCode;
    this.domain = a.domain;
    this.appId = a.appId;
    this.status = a.status;
    this.level = a.level;
    this.scaleLevel = a.scaleLevel;
    this.isVerified = a.isVerified;
    this.isFromComp = a.isFromComp;
    this.isCompValid = a.isCompValid;
    this.trialExpired = a.trialExpired;
    this.isBlocked = a.isBlocked;
    this.trialExpiredAt = a.trialExpiredAt;
    this.copyright = a.copyright;
    this.version = a.version;
    this.agreeBroadcast = a.agreeBroadcast;
    this.funcInfo = a.funcInfo;
    this.isPayOpen = a.isPayOpen;
    this.crmCreate = a.crmCreate;
    this.gmtCreate = a.gmtCreate;
    this.gmtModified = a.gmtModified;
  }
}

export interface AccountState {
  account: Account | any;
  hasLoginAcount: boolean;
  hasLogin: boolean;
  changeAccountNum: number;
  changeCrmLevelNum: number;
  crmLevel?: any;
  isTrial: boolean;
  fansLevel: number;
  isExpired: boolean;
}

export const accountState: AccountState = {
  account: {},
  crmLevel: null,
  hasLoginAcount: false,
  hasLogin: false,
  changeAccountNum: 0,
  changeCrmLevelNum: 0,
  isTrial: false,
  fansLevel: 1,
  isExpired: false,
};

export enum AccountLevel {
  Level0 = 0,
  Level1 = 1,
  Level2 = 2,
  Level3 = 3,
}
